import { CHANGE_MENU_STATE } from './types'

const menuState = {
    open: true,
}

const menuReducer = (state, actions) => {
    const { type } = actions

    switch (type) {
        case CHANGE_MENU_STATE:
          return {
              ...state,
              open: !state.open,
          }
        default: {
          return state
        }
    }
}

export { menuReducer as default, menuState }